import { render, staticRenderFns } from "./GroupBanner.vue?vue&type=template&id=b57985a8&scoped=true"
import script from "./GroupBanner.vue?vue&type=script&lang=js"
export * from "./GroupBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57985a8",
  null
  
)

export default component.exports